// Services
import { AccountService } from 'src/app/services/account.service';
import { AgentCRMService } from 'src/app/services/agent-crm.service';
import { AgentService } from 'src/app/services/agent.service';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { BenefitService } from 'src/app/services/benefit.service';
import { BeneficiariesService } from 'src/app/services/beneficiaries.service';
import { ContactsService } from 'src/app/services/contacts.service';
import { DependentsService } from 'src/app/services/dependents.service';
import { EnrollmentAddService } from 'src/app/services/enrollment-add.service';
import { EnrollmentBuyupService } from 'src/app/services/enrollment-buyup.service';
import { EnrollmentCancelService } from 'src/app/services/enrollment-cancel.service';
import { EnrollmentCheckoutService } from 'src/app/services/enrollment-checkout.service';
import { EnrollmentDashboardService } from 'src/app/services/enrollment-dashboard.service';
import { EnrollmentManagerService } from 'src/app/services/enrollment-manager.service';
import { EnrollmentOnboardService } from 'src/app/services/enrollment-onboard.service';
import { EnrollmentTermService } from 'src/app/services/enrollment-term.service';
import { EnrollmentWaiveService } from 'src/app/services/enrollment-waive.service';
import { EnrollmentWidgetService } from 'src/app/services/enrollment-widget.service';
import { FileService } from 'src/app/services/file.service';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { HelperService } from 'src/app/services/helper.service';
import { LookupService } from 'src/app/services/lookup.service';
import { LocalStorageService } from 'src/app/services/storage/local-storage.service';
import { MaskService } from 'src/app/services/mask.service';
import { MemberService } from 'src/app/services/member.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { QLEService } from 'src/app/services/qle.service';
import { ReportsService } from 'src/app/services/reports.service';
import { DocumentService } from 'src/app/services/documents.service';
import { SessionService } from 'src/app/services/storage/session.service';
import { StyleService } from 'src/app/services/styles.service';
import { TableService } from 'src/app/services/table.service';
import { ToastService } from 'src/app/services/toast.service';
import { TranslationService } from 'src/app/services/translation.service';
import { USAePayService } from 'src/app/services/usaepay.service';
import { VoyaService } from 'src/app/services/voya.service';
import { PayrollService } from '../services/payroll.service';
import { EncryptionService } from '../services/encryption.service';
import { AppGateService } from '../services/app-gate.service';


export const Services = [
  AccountService,
  AgentCRMService,
  AgentService,
  ApiService,
  AuthService,
  BenefitService,
  BeneficiariesService,
  ContactsService,
  DependentsService,
  EnrollmentAddService,
  EnrollmentBuyupService,
  EnrollmentCancelService,
  EnrollmentCheckoutService,
  EnrollmentDashboardService,
  EnrollmentOnboardService,
  EnrollmentManagerService,
  EnrollmentTermService,
  EnrollmentWaiveService,
  EnrollmentWidgetService,
  FileService,
  FileUploadService,
  HelperService,
  LookupService,
  LocalStorageService,
  MaskService,
  MemberService,
  NavigationService,
  PayrollService,
  QLEService,
  ReportsService,
  DocumentService,
  SessionService,
  StyleService,
  TableService,
  ToastService,
  TranslationService,
  USAePayService,
  VoyaService,
  EncryptionService,
  AppGateService
];